import React from "react";

import { SubHeading } from "../../components";
import { images, data } from "../../constants";
import "./Laurels.css";

const AwardCard = ({ award: { imgUrl, title, subtitle } }) => (
  <div className="app__laurels-awards_card">
    <img src={imgUrl} alt="imgurl" />
    <div className="app__laurels-awards_card-content">
      <p className="p__cormorant" style={{ color: "#dcca87" }}>
        {title}
      </p>
      <p className="p__cormorant">{subtitle}</p>
    </div>
  </div>
);

const Laurels = () => (
  <div className="app__bg app__wrapper section__padding" id="awards">
    <div className="app__wrapper-info">
      <SubHeading title="Awards and Recognition" />

      <h1 className="headtext__cormorant">Our Laurels</h1>

      <div className="app__laurels-awards">
        {data.awards.map((award, idx) => (
          <AwardCard award={award} key={idx + award.imgUrl} />
        ))}
      </div>
    </div>

    <div className="app__wrapper-img">
      <img src={images.laurels} alt="laurels" />
    </div>
  </div>
);

export default Laurels;
